exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3VfFG{margin-left:12px}._9aGgY{margin-bottom:36px}\n", ""]);

// Exports
exports.locals = {
	"text-button": "_3VfFG",
	"textButton": "_3VfFG",
	"section": "_9aGgY"
};